import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/MainSlider.css";

import img1 from "../../assets/images/main-slider/image-01.jpg";
import img2 from "../../assets/images/main-slider/image-02.jpg";
import img3 from "../../assets/images/main-slider/image-03.webp";
import img4 from "../../assets/images/main-slider/image-04.webp";

import trustedBoxImg from "../../assets/images/main-slider/image-0.jpg";

function MainSlider() {
  const { t } = useTranslation();

  return (
    <section className="hero-section">
      {/* ── Background carousel ── */}
      <Carousel
        interval={6000}
        fade
        controls={false}
        indicators={false}
        pause={false}
      >
        {[ img1, img2, img3, img4].map((src, i) => (
          <Carousel.Item key={i}>
            <img
              className="hero-slide-img"
              src={src}
              alt={`Al Madina Steel slide ${i + 1}`}
            />
          </Carousel.Item>
        ))}
      </Carousel>

      {/* ── Dark navy overlay ── */}
      <div className="hero-overlay" />

      {/* ── Content layer ── */}
      <div className="hero-content">
        <div className="container">
          <div className="row align-items-center g-4">

            {/* LEFT — headline + buttons */}
            <div className="col-lg-7 hero-text-col">
              <span className="hero-brand-label hero-anim hero-anim-1">Al Madina Steel</span>
              <h1 className="hero-headline hero-anim hero-anim-2">{t("hero-headline")}</h1>
              <p className="hero-subtext hero-anim hero-anim-3">{t("hero-subtext")}</p>
              <div className="hero-buttons hero-anim hero-anim-4">
                <Link to="/who-we-are" className="btn-primary-custom">
                  {t("Know More")}
                </Link>
                <Link to="/contact-us" className="btn-outline-custom">
                  {t("Contact Us")}
                </Link>
              </div>
            </div>

            {/* RIGHT — trust image */}
            <div className="col-lg-5 hero-stats-col hero-anim hero-anim-5" dir="rtl">
              <div className="trust-box mt-5">
                <img
                  src={trustedBoxImg}
                  alt="Al Madina Steel"
                  width={350}
                  height={250}
                  style={{ objectFit: "cover", borderRadius: "12px", border: "3px solid white" }}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default MainSlider;
